function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { createContext, useEffect, useState } from 'react';
import { LoadingOverlay, Modal, ModalBody, ModalHeader } from '@deephaven/components';
import Log from '@deephaven/log';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('@deephaven/jsapi-bootstrap.ApiBootstrap');
export var ApiContext = /*#__PURE__*/createContext(null);
ApiContext.displayName = 'ApiContext';
/**
 * ApiBootstrap loads the API from the provided URL, rendering the children once loaded.
 */
export function ApiBootstrap(_ref) {
  var {
    apiUrl,
    children,
    failureElement,
    setGlobally = false
  } = _ref;
  var [isLoading, setIsLoading] = useState(true);
  var [api, setApi] = useState();
  useEffect(() => {
    function loadApi() {
      return _loadApi.apply(this, arguments);
    }
    function _loadApi() {
      _loadApi = _asyncToGenerator(function* () {
        try {
          var dh =
          // Ignore the warning about dynamic import in both Vite and Webpack.
          // We use Vite, but some clients may use Webpack.
          (yield import(/* @vite-ignore */ /* webpackIgnore: true */apiUrl)).default;
          log.info('API bootstrapped from', apiUrl);
          setApi(dh);
          if (setGlobally) {
            log.debug('API set globally');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            globalThis.dh = dh;
          }
        } catch (e) {
          log.error('Unable to bootstrap API', e);
        }
        setIsLoading(false);
      });
      return _loadApi.apply(this, arguments);
    }
    loadApi();
  }, [apiUrl, setGlobally]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      "data-testid": "api-bootstrap-loading"
    });
  }
  if (api == null) {
    return failureElement !== null && failureElement !== void 0 ? failureElement : /*#__PURE__*/_jsxs(Modal, {
      isOpen: true,
      className: "modal-dialog-centered",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        closeButton: false,
        children: "Error: Unable to load API"
      }), /*#__PURE__*/_jsx(ModalBody, {
        children: /*#__PURE__*/_jsxs("p", {
          className: "text-break",
          children: ["Ensure the server is running and you are able to reach ", apiUrl, ", then refresh the page."]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(ApiContext.Provider, {
    value: api,
    children: children
  });
}
export default ApiBootstrap;
//# sourceMappingURL=ApiBootstrap.js.map